/// <amd-module name="Feed/Legacy/Protocols/Npm/NpmOverviewContentPanel" />
import * as React from "react";

import { CiConstants } from "Feed/Common/Constants/Constants";
import * as PackageResources from "Feed/Common/Resources";
import { ConnectToFeedButton } from "Feed/Legacy/Components/ConnectToFeedButton";
import { PackageUpstreamLocatorCommand } from "Feed/Legacy/Components/PackageUpstreamLocatorCommand";
import { IPackageDetailsProps } from "Feed/Legacy/Protocols/Common/IPackageDetailsProps";
import { IPackageProtocol } from "Feed/Legacy/Protocols/Common/IPackageProtocol";
import { CopyableTextField, ICopyableTextFieldTelemetry } from "Feed/Legacy/Protocols/Components/CopyableTextField";
import { MarkdownRendererWrapper } from "Feed/Legacy/Protocols/Components/MarkdownRendererWrapper";
import { PackageTile } from "Feed/Legacy/Protocols/Components/PackageTile";
import { INpmDataService, INpmReadmeContent } from "Feed/Legacy/Protocols/Npm/NpmDataService";
import { HubAction } from "Feed/Legacy/Types/IHubState";

export interface INpmOverviewContentPanelState {
    rawReadmeContent?: string;
}

export class NpmOverviewContentPanel extends React.Component<IPackageDetailsProps, INpmOverviewContentPanelState> {
    private _mounted: boolean;

    constructor(props: IPackageDetailsProps) {
        super(props);

        this.state = {
            rawReadmeContent: null
        } as INpmOverviewContentPanelState;

        this._mounted = false;
    }

    public componentDidMount(): void {
        const npmDataService = this.props.pageContext.getService<INpmDataService>("INpmDataService");
        this._mounted = true;
        npmDataService
            .getReadmeUnscopedPackage(
                this.props.feed,
                this.props.packageSummary.normalizedName,
                this.props.packageVersion.normalizedVersion
            )
            .then((readmeContent: INpmReadmeContent) => {
                // only set state if you're still in the overview tab after readme fetching is done
                if (this._mounted === true) {
                    this.setState({
                        rawReadmeContent: readmeContent.rawReadmeContent
                    });
                }
            });
    }

    public componentWillUnmount(): void {
        this._mounted = false;
    }

    public render(): JSX.Element {
        const { feed, packageVersion, packageSummary, protocol } = this.props;

        const protocolMap: { [key: string]: IPackageProtocol } = {};
        protocolMap[protocol.name] = protocol;
        const textfieldId = "npm-overview-textfield-label1";

        return (
            <div className="package-overview-content-panel">
                {!packageVersion.isDeleted && (
                    <PackageTile title={PackageResources.Npm_InstallInstructions_Title} id={textfieldId}>
                        <div>
                            <div className="get-package-tile">
                                <ConnectToFeedButton
                                    pageContext={this.props.pageContext}
                                    feed={feed}
                                    feedViews={this.props.feedViews}
                                    protocolMap={protocolMap}
                                    hubAction={HubAction.Package}
                                />
                                <span className="install-instructions-then">
                                    {PackageResources.InstallInstructions_then}
                                </span>
                                <CopyableTextField
                                    pageContext={this.props.pageContext}
                                    text={protocol.getCopyInstallCommand(feed, packageSummary.name, packageVersion)}
                                    buttonAriaLabel={PackageResources.AriaLabel_CopyToClipBoard_Npm_Install_Copy}
                                    textFieldAriaLabel={PackageResources.AriaLabel_CopyToClipBoard_Npm_Install}
                                    telemetryProperties={
                                        {
                                            commandName: CiConstants.CopyCommandInstall,
                                            feedName: feed.name,
                                            packageName: packageSummary.name,
                                            packageVersion: packageVersion.version,
                                            protocol: protocol.name
                                        } as ICopyableTextFieldTelemetry
                                    }
                                    ariaDescribedByIdForLabelText={textfieldId}
                                />
                            </div>
                        </div>
                        <PackageUpstreamLocatorCommand
                            pageContext={this.props.pageContext}
                            feed={feed}
                            packageVersion={packageVersion}
                            protocol={protocol}
                        />
                    </PackageTile>
                )}
                <PackageTile title={PackageResources.Npm_Description_Title}>
                    <div className="package-description">{packageVersion.description}</div>
                </PackageTile>
                {!packageVersion.isDeleted && this.state.rawReadmeContent && (
                    <PackageTile>
                        <MarkdownRendererWrapper
                            pageContext={this.props.pageContext}
                            rawMarkdownContent={this.state.rawReadmeContent}
                        />
                    </PackageTile>
                )}
            </div>
        );
    }
}
